import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectEnabledPreviews } from 'modules/app/selectors';
import { DiamondLogo } from 'ui/logo';
import { Link } from 'ui/links';
import { H1, spacing, largeShadow, colors } from 'ui/theme';

const App = styled.div`
  padding: 0 ${spacing.double};
`;

const StickyHeader = styled.header`
  margin-left: -${spacing.double};
  margin-right: -${spacing.double};
  position: sticky;
  top: 0px;
  /* sets z-index to 1000. the navigation header shouldn't be higher than
  angular modals (z-index 1004) that show up when editing feature flags */
  z-index: 1000;
`;

const AdminHeader = styled.div`
  background: ${colors.backgroundSecondary};
  padding: ${spacing.base};
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: ${spacing.base};
  h1 {
    margin: 0;
  }
  a:hover {
    text-decoration: none;
  }
  ${largeShadow}
`;

const Content = styled.div`
  padding-top: ${spacing.base};
`;

export const AdminAppLayout = ({ children }) => {
  const enabledPreviews = useSelector(selectEnabledPreviews);
  const adminAppLinks = [
    { text: 'Admin endpoints', url: '/admin/endpoints' },
    { text: 'Feature flags', url: '/admin/featureFlags' },
    { text: 'Metric definitions', url: '/admin/metricDefinitions' },
    { text: 'Database configs', url: '/admin/databaseConfigs' },
  ];
  if (enabledPreviews.includes('internalTools')) {
    adminAppLinks.push({
      text: 'Internal tools',
      url: '/admin/internalTools?previews=internalTools',
    });
  }
  return (
    <App data-global-nav={true}>
      <StickyHeader data-test="sticky-nav">
        <AdminHeader>
          <DiamondLogo width={32} height={32} />
          <H1>ADMINERABLE</H1>
          {adminAppLinks.map((link) => (
            <Link key={link.url} href={link.url} useReactRouter>
              {link.text}
            </Link>
          ))}
        </AdminHeader>
      </StickyHeader>
      <Content data-id="routes-container">{children}</Content>
    </App>
  );
};
